export const PollType = Object.freeze({
  FUNDING: 3,
  RANKING: 2,
});

export const PollTypeOptions = Object.freeze([
  { value: PollType.FUNDING, label: "서포트 투표" },
  { value: PollType.RANKING, label: "랭킹 투표" },
]);
